import React, { Component } from 'react';

import { Row } from 'react-bootstrap';
import CurriculumVitaeButton from './buttons/CurriculumVitaeButton'
import LegalAreasButton from './buttons/LegalAreasButton'
import WorksButton from './buttons/WorksButton'
import ContactButton from './buttons/ContactButton'

import vaga from '../static/images/vaga.jpg'

export default class Index extends Component {
    render() {
        return (
            <div>
                <Row>
                    <CurriculumVitaeButton />
                    <LegalAreasButton />
                    <WorksButton />
                    <ContactButton />
                </Row>
                <br />
                <img src={vaga} className="bigPic" alt="And justice for all..." />
                <hr />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/screens/Index.js